module.exports = __webpack_public_path__ + "static/media/11. Proceso de apertura, Mixta en tela, 150 x 140 cm, 2016  copy.19c696a2.png";